import React, { useContext, useEffect, useRef, useState } from "react";
import "./shipementReport.css";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ListIcon from "@mui/icons-material/List";
import Loading from "../../../order_managment/screens/loading/Loading";
import {
  Backdrop,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import ColumnSelectModal from "./Modal/ColumnSelectModal";
import FilterModalShipmentReport from "./Modal/FilterModalShipmentReport";
import instance from "../../../order_managment/common/api/interceptor";
import { path } from "../../../order_managment/constants/apiPath";
import ShipmentReportTableHead from "./ShipmentReportTableHead";
import ShipmentReportTableBody from "./ShipmentReportTableBody";
import { HOST_URL } from "../../../config";
import InfiniteScroll from "react-infinite-scroller";
import NoData from "../../../order_managment/screens/noData/NoData";
import { filterKey } from "./shipementReportFilterObj";
import { StoreContext } from "../../../order_managment/store";
import { NotificationManager } from "react-notifications";
const axios = require("axios");

const ShipmentReport = () => {
  const context = useContext(StoreContext);
  const [loadmoreData, setLoadMoreData] = useState(false);
  const [orderBy, setOrderBy] = useState("desc");
  const [order, setOrder] = useState("Shipment Number");
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [coloumn, setColoumn] = useState([]);
  const [reportInformation, setReportInformation] = useState([]);
  const [bodyData, setBodyData] = useState({ ...filterKey });
  const [backDropLoader, setBackDropLoader] = useState(false);
  const [selectModal, setSelectModal] = useState({
    filter: false,
    selectCol: false,
  });
  const onLoadMore = () => {
    const count = pageNumber + 1;
    if (hasMore) {
      setLoadMoreData(true);
      getInformaiton(order, orderBy, count, { ...bodyData });
    }
  };
  const getColoumn = async () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${HOST_URL}${path.SHIPMENT_COLOUM}${
        JSON.parse(localStorage.getItem("UserDataLogin")).user_name
      }`,
      headers: {
        Username: JSON.parse(localStorage.getItem("UserDataLogin")).user_name,
        Usersecret: JSON.parse(localStorage.getItem("UserDataLogin")).password,
        Macaddress: "",
        Ipaddress: "",
        Devicetype: "W",
      },
    };
    await axios
      .request(config)
      .then((response) => {
        setColoumn(response?.data?.value);
      })
      .catch((error) => {
        console.log(error);
      });
    await getInformaiton(order, orderBy, 0, { ...bodyData });
  };
  const onFillterHandler = (body) => {
    setLoading(true);
    getInformaiton(order, orderBy, 0, { ...body });
    setBodyData({ ...body });
  };
  const handleRequestSort = async (property) => {
    setBackDropLoader(true);
    setPageNumber(0);
    const isAsc = orderBy === property && order === "asc";
    setOrderBy(isAsc ? "desc" : "asc");
    setOrder(property);
    getInformaiton(property, isAsc ? "desc" : "asc", 0, {
      ...bodyData,
    });
  };
  const handleRequestColoumnUpdate = () => {
    setLoading(true);
    getInformaiton();
  };
  const getInformaiton = async (
    SortColumnName = order,
    SortDirection = orderBy,
    CurrentPage = pageNumber,
    bodyData
  ) => {
    setHasMore(false);
    const data = {
      ...bodyData,
      SortColumnName: SortColumnName?.split(" ")?.join(""),
      SortDirection,
      CurrentPage,
      PageSize: 20,
    };
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${HOST_URL}${path.SHIPMENT_DATA}${
        JSON.parse(localStorage.getItem("UserDataLogin")).user_name
      }`,
      headers: {
        Username: JSON.parse(localStorage.getItem("UserDataLogin")).user_name,
        Usersecret: JSON.parse(localStorage.getItem("UserDataLogin")).password,
        Macaddress: "",
        Ipaddress: "",
        Devicetype: "W",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        if (CurrentPage == 0) {
          console.log("is condition adjfasdjflsad");
          setReportInformation(response?.data?.value ?? []);
        } else {
          console.log("else condition adjfasdjflsad");
          setReportInformation((prev) => [...prev, ...response?.data?.value]);
        }
        setPageNumber(CurrentPage);
        console.log(
          response?.data?.totalItem > (CurrentPage + 1) * 20,
          "internal informaiton"
        );
        setHasMore(response?.data?.totalItem > (CurrentPage + 1) * 20);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
        setLoadMoreData(false);
        setBackDropLoader(false);
      });
  };
  
  useEffect(() => {
    getColoumn();
  }, []);
  const downloadExcelFile = (data = "") => {
    const base64Data = data; // Your base64 string here
    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "SHIPMENT_REPORT.xlsx");
    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      URL.revokeObjectURL(url);
      document.body.removeChild(link);
    }, 0);
  };
  const onDownload = () => {
    context.setBackDropOpen(true);
    const body = {
      _ColList: "",
      ...bodyData,
      ColList: "",
      SortColumnName: "",
      SortDirection: "",
      CurrentPage: 0,
      PageSize: 0,
    };
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${HOST_URL}${path.DOWNLOAD_SHIPMENT_REPORT}${
        JSON.parse(localStorage.getItem("UserDataLogin")).user_name
      }`,
      headers: {
        Username: JSON.parse(localStorage.getItem("UserDataLogin")).user_name,
        Usersecret: JSON.parse(localStorage.getItem("UserDataLogin")).password,
        Macaddress: "",
        Ipaddress: "",
        Devicetype: "W",
      },
      data: body,
    };
    axios
      .request(config)
      .then((response) => {
        downloadExcelFile(response?.data?.value);
      })
      .catch((error) => {
        NotificationManager.error(error?.Message, "", 3000);
        console.log(error);
      })
      .finally(() => {
        context.setBackDropOpen(false);
      });
  };
  return (
    <>
      {
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={backDropLoader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      }
      <div className="_systemLog">
        <div className="_sytemSortDialog">
          <div className="_systemLogFilterParent">
            <div
              className="_systemLogFilter"
              onClick={() => {
                // context.setModalOpen(true);
                // setModalType("filter");
                setSelectModal({
                  filter: true,
                  selectCol: false,
                });
              }}
            >
              <FilterAltOutlinedIcon />
            </div>
            <div
              className="_systemLogFilter"
              onClick={() => {
                // context.setModalOpen(true);
                setSelectModal({
                  filter: false,
                  selectCol: true,
                });
              }}
            >
              <ListIcon />
            </div>
          </div>

          <div className="_outlineButton">
            <button
              disabled={reportInformation.length > 0 ? false : true}
              onClick={onDownload}
            >
              Download Report
            </button>
          </div>
        </div>

        <div
          className={`_tableScroll _systemLogTable reportTable`}
          // id="scrollabletable"
        >
          {loading ? (
            <Loading />
          ) : (
            <TableContainer
              component={Paper}
              className="_tableScrollTableContainer"
            >
              {!reportInformation.length ? (
                <NoData>
                  <p>Report not Found!</p>
                </NoData>
              ) : (
                <InfiniteScroll
                  className="infiniteScroller"
                  // scrollableTarget="scrollabletable"
                  pageStart={0}
                  // dataLength={reportInformation?.length} //This is important field to render the next data
                  loadMore={onLoadMore}
                  hasMore={hasMore}
                  // loader={
                  //   <div>
                  //     <Loading />
                  //   </div>
                  // }
                  useWindow={false}
                >
                  <Table stickyHeader id="downloadTable">
                    {/* header */}
                    <ShipmentReportTableHead
                      coloumn={coloumn}
                      handleRequestSort={handleRequestSort}
                      orderBy={orderBy}
                      order={order}
                    />
                    {/* body */}
                    <ShipmentReportTableBody
                      coloumn={coloumn}
                      reportInformation={reportInformation}
                    />
                  </Table>
                  {loadmoreData  && (
                    <div style={{height : "70px"}}>
                      <Loading />
                    </div>
                  )}
                </InfiniteScroll>
              )}
            </TableContainer>
          )}
        </div>
      </div>
      {selectModal.selectCol && (
        <ColumnSelectModal
          setSelectModal={setSelectModal}
          selectModal={selectModal}
          coloumn={coloumn}
          setColoumn={setColoumn}
          handleRequestColoumnUpdate={handleRequestColoumnUpdate}
        />
      )}
      {selectModal.filter && (
        <FilterModalShipmentReport
          onFillterHandler={onFillterHandler}
          setSelectModal={setSelectModal}
          selectModal={selectModal}
          bodyData={bodyData}
        />
      )}
    </>
  );
};

export default ShipmentReport;
